import React, { createContext, useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { User } from '../services/auth'

import { ThemeContext } from '../components/ThemeContext'

type AuthContextProps = {
    user: User | null
    login: (user: User) => void
    logout: () => void
}

const AuthContext = createContext<AuthContextProps | undefined>(undefined)

type AuthProviderProps = {
    user: User | null
    children: React.ReactElement
}

const AuthProvider: React.FC<AuthProviderProps> = ({ user, children }) => {
    const navigate = useNavigate()
    const [loggedInUser, setLoggedInUser] = useState(user)

    const { applyTheme } = useContext(ThemeContext)

    console.log('render auth provider')

    const login = (newUser: User) => {
        setLoggedInUser(newUser)

        const theme = newUser.object.theme ?? 'dark'
        localStorage.setItem('theme', theme)
        applyTheme(theme)

        localStorage.setItem('refresh_time', Date.now().toString())
        localStorage.setItem('access_token', newUser.token)

        if (process.env.REACT_APP_MODE == 'site') {
            window.location.href = 'https://223.noxsys.ru'
        } else {
            navigate('/hub')
        }
    }

    const logout = () => {
        setLoggedInUser(null)
        localStorage.clear()

        if (process.env.REACT_APP_MODE == 'system') {
            window.location.href = 'https://noxsys.ru'
        } else {
            navigate('/', { replace: true })
        }
    }

    return (
        <AuthContext.Provider value={{ user: loggedInUser, login, logout }}>
            {children}
        </AuthContext.Provider>
    )
}

const useAuth = (): AuthContextProps => {
    const context = useContext(AuthContext)
    if (context === undefined) {
        throw new Error('useAuth must be used within an AuthProvider')
    }
    return context
}

export { AuthProvider, useAuth }
